import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import ToastContainer, { ToastData, ToastType } from '../components/ui/Toast';
interface ToastOptions { duration?: number; }
interface ToastContextValue {
  addToast: (type: ToastType, title: string, message?: string, options?: ToastOptions) => string;
  dismissToast: (id: string) => void;
  success: (title: string, message?: string, options?: ToastOptions) => string;
  error: (title: string, message?: string, options?: ToastOptions) => string;
}
const Context = createContext<ToastContextValue | null>(null);
export function useToast() { const context = useContext(Context); if (!context) throw new Error('useToast requires ToastProvider.'); return context; }
export const ToastProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [toasts,setToasts] = useState<ToastData[]>([]);
  const addToast = useCallback((type:ToastType,title:string,message?:string,options?:ToastOptions) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    setToasts(prev=>[...prev.filter(t=>t.type!==type || t.title!==title || t.message!==message).slice(-4),{id,type,title,message,duration:options?.duration}]); return id;
  },[]);
  const dismissToast = useCallback((id:string)=>setToasts(prev=>prev.filter(t=>t.id!==id)),[]);
  const value = useMemo(()=>({addToast,dismissToast,success:(title:string,message?:string,options?:ToastOptions)=>addToast('success',title,message,options),error:(title:string,message?:string,options?:ToastOptions)=>addToast('error',title,message,options)}),[addToast,dismissToast]);
  return <Context.Provider value={value}>{children}<ToastContainer toasts={toasts} onDismiss={dismissToast}/></Context.Provider>;
};
